import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

// Modules
import user from './user'
import events from './events'
import partners from './partners'
import translators from './translators'
import chats from './chats'
import countries from './countries'
import bugReport from './bugReport'
import systemSetup from './systemSetup'
import customers from './customers'
import contacts from './contacts'
import maps from './maps'
import uploader from './uploader'

import israelIdValidator from '../utils/israelIdValidator';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    events,
    partners,
    translators,
    chats,
    countries,
    bugReport,
    systemSetup,
    customers,
    contacts,
    maps,
    uploader
  },
  state: {
    // DB
    entities: {
      contacts: {},
      contactsList: [],
      chats: {},
      chatsList: {},
      chatMessages: {},
      chatMessagesList: {},
      contactDetailTypes: {},
      contactDetailTypesList: [],
      contactDetails: {},
      contactDetailsList: [],
      events: {},
      insuranceCompanies: {},
      insuranceCompaniesList: [],
      arans: {},
      aransList: [],
      hashtags: {},
      hashtagsList: [],
      languages: {},
      languagesList: [],
      countries: {},
      countriesList: [],
      // fullCountries: {},
      // fullCountriesList: [],
      regions: {},
      regionsList: [],
      // fullRegions: {},
      // fullRegionsList: [],
      partners: {},
      partnersList: [],
      translators: {},
      translatorsList: [],
      partnerRelationships: {},
      partnerRelationshipsList: [],
      partnerReviews: {},
      partnerTypes: {},
      partnerTypesList: [],
      eventTypes: {},
      eventTypesList: [],
      eventSubTypes: {},
      eventSubTypesList: [],
      eventSources: {},
      eventSourcesList: [],
      roles: {},
      rolesList: [],
      duties: {},
      dutiesList: [],
      users: {},
      usersList: [],
      firebaseUsers: {},
      firebaseUsersList: [],
      mapMarkerTypes: {},
      mapMarkerTypesList: [],
      events: {},
      eventsList: [],
      customers: {},
      customersList: [],
      genders: {},
      gendersList: [],
      standards: {},
      standardsList: [],
      standardGroups: {},
      standardGroupsList: [],
      activityLogs: {},
      activityLogsList: [],
      evacuationTypes: {},
      evacuationTypesList: [],
      standardReportRows: {},
      standardReportRowsList: [],
      partnerEventFiles: {},
      partnerEventFilesList: []
    },
    editableEntities: {
      contactDetailTypes: {},
      contactDetails: {},
      customers: {},
      events: {},
      insuranceCompanies: {},
      arans: {},
      hashtags: {},
      languages: {},
      countries: {},
      // fullCountries: {},
      regions: {},
      genders: {},
      // fullRegions: {},
      duties: [],
      partners: {},
      translators: {},
      contacts: {},
      partnerRelationships: {},
      partnerReviews: {},
      partnerTypes: {},
      eventTypes: {},
      eventSubTypes: {},
      eventSources: {},
      roles: {},
      users: {},
      mapMarkerTypes: {},
      chats: {},
      chatMessages: {},
      users: {},
      standards: {},
      standardGroups: {},
      activityLogs: {},
      evacuationTypes: {},
      partnerEventFiles: {}
    },

    entityViewDialog: false,

    entityEditDialog: false,
    entityEditData: {
      id: null,
      fields: null,
      resource: null,
      mainId: null,
      mainResource: null,
    },

    resources: {
      partner: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [v => !!v || 'חובה להזין שם'],
            required: true
          },
          created: {
            type: 'DATE',
            name: 'תאריך יצירה',
            validationRules: [],
            required: false
          },
          created: {
            type: 'DATE',
            name: 'תאריך יצירה',
            validationRules: [],
            required: false
          },
          lastValidation: {
            type: 'DATE',
            name: 'תאריך אימות',
            validationRules: [],
            required: false
          },
          types: {
            type: 'SELECT',
            items: 'partnerTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: true,
            name: 'סוג ספק',
            validationRules: [],
            required: false
          },
          relationship: {
            type: 'SELECT',
            items: 'partnerRelationships',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג קשר',
            validationRules: [],
            required: false
          },
          countries: {
            type: 'SELECT',
            items: 'countries',
            itemText: 'name',
            itemValue: '_id',
            isMultiple: true,
            aggregateFrom: 4,
            name: 'מדינות',
            validationRules: [v => !!v.length || 'יש לבחור מדינה אחת לפחות'],
            required: true
          },
          regions: {
            type: 'SELECT',
            itemsGetter: {
              getter: 'countries/countryRegions',
              depandsOn: 'countries'
            },
            itemText: 'name',
            itemValue: '_id',
            isMultiple: true,
            aggregateFrom: 4,
            name: 'איזורים',
            validationRules: [],
            required: false
          },
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            validationRules: [],
            required: false
          },
          researcherNotes: {
            type: 'TEXTAREA',
            name: 'הערות חוקר/ת',
            validationRules: [],
            required: false
          },
          recommended: {
            type: 'BOOLEAN',
            name: 'מומלץ',
            validationRules: [],
            required: false
          },
          callFirst: {
            type: 'BOOLEAN',
            name: 'ליצור קשר ראשון',
            validationRules: [],
            required: false
          }
        },
        endpoint: 'partners',
        entityType: 'partners',
        schema: 'partnerSchema',
        listSchema: 'partnerListSchema',
        fullscreenEditDialog: true,
        name: 'ספק',
        highlightKey: 'callFirst',
        namePlural: ''
      },
      translator: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [v => !!v || 'חובה להזין שם'],
            required: true
          },
          created: {
            type: 'DATE',
            name: 'תאריך יצירה',
            validationRules: [],
            required: false
          },
          lastValidation: {
            type: 'DATE',
            name: 'תאריך אימות',
            validationRules: [],
            required: false
          },
          languages: {
            type: 'SELECT',
            items: 'languages',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: true,
            aggregateFrom: 4,
            name: 'שפות',
            validationRules: [v => !!v.length || 'יש לבחור שפה אחת לפחות'],
            required: true
          },
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            validationRules: [],
            required: false
          },
          researcherNotes: {
            type: 'TEXTAREA',
            name: 'הערות חוקר/ת',
            validationRules: [],
            required: false
          },
          recommended: {
            type: 'BOOLEAN',
            name: 'מומלץ',
            validationRules: [],
            required: false
          },
          callFirst: {
            type: 'BOOLEAN',
            name: 'ליצור קשר ראשון',
            validationRules: [],
            required: false
          }
        },
        endpoint: 'translators',
        entityType: 'translators',
        schema: 'translatorSchema',
        listSchema: 'translatorListSchema',
        fullscreenEditDialog: true,
        name: 'מתורגמן',
        highlightKey: 'callFirst',
        namePlural: 'מתורגמנים'
      },
      contactDetail: {
        model: {
          type: {
            type: 'SELECT',
            items: 'contactDetailTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג',
            validationRules: [v => !!v || 'חובה לבחור סוג'],
            required: true
          },
          data: {
            type: 'TEXT',
            name: 'מידע',
            validationRules: [v => !!v || 'חובה להזין מידע'],
            hint: 'למשל עבור מספר טלפון: 972501122333',
            ltr: true,
            required: true
          },
          description: {
            type: 'TEXT',
            name: 'תיאור מילולי קצר',
            validationRules: [],
            required: false
          },
          partner: {
            type: 'HIDDEN'
          },
          contact: {
            type: 'HIDDEN'
          },
          customer: {
            type: 'HIDDEN'
          }
        },
        endpoint: '/contact-details',
        entityType: 'contactDetails',
        schema: 'contactDetailSchema',
        listSchema: 'contactDetailListSchema',
        fullscreenEditDialog: false,
        name: 'פרט קשר',
        namePlural: ''
      },
      contact: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם מלא',
            validationRules: [v => !!v || 'חובה להזין שם'],
            required: true
          },
          role: {
            type: 'TEXT',
            name: 'תפקיד',
            validationRules: [],
            required: false
          },
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            validationRules: [],
            required: false
          },
          languages: {
            type: 'SELECT',
            items: 'languages',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: true,
            name: 'שפות',
            validationRules: [],
            required: false
          },
          callFirst: {
            type: 'BOOLEAN',
            name: 'ליצור קשר ראשון',
            validationRules: [],
            required: false
          },
          partner: {
            type: 'HIDDEN'
          },
          translator: {
            type: 'HIDDEN'
          },
          event: {
            type: 'HIDDEN'
          }
        },
        endpoint: '/contacts',
        entityType: 'contacts',
        schema: 'contactSchema',
        listSchema: 'contactListSchema',
        fullscreenEditDialog: false,
        name: 'איש קשר',
        namePlural: 'אנשי קשר'
      },
      eventContact: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [v => !!v || 'חובה להזין שם'],
            required: true
          },
          phone: {
            type: 'TEXT',
            name: 'טלפון',
            validationRules: [
              v => !v || /^[0-9+\-\s()]*$/.test(v) || 'מספר טלפון לא תקין'
            ],
            hint: 'למשל: 972501234567',
            ltr: true,
            required: false
          },
          role: {
            type: 'TEXT',
            name: 'קרבה / תפקיד',
            validationRules: [],
            hint: 'למשל: אבא, חברה, חבר לטיול',
            required: false
          },
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            validationRules: [],
            required: false
          },
          languages: {
            type: 'SELECT',
            items: 'languages',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: true,
            name: 'שפות',
            validationRules: [],
            required: false
          },
          event: {
            type: 'HIDDEN'
          }
        },
        endpoint: '/contacts',
        entityType: 'contacts',
        schema: 'contactSchema',
        listSchema: 'contactListSchema',
        fullscreenEditDialog: false,
        name: 'איש קשר',
        namePlural: 'אנשי קשר'
      },
      partnerType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          titlePlural: {
            type: 'TEXT',
            name: 'כותרת (רבים)',
            validationRules: [v => !!v || 'חובה להזין כותרת בצורת רבים'],
            required: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע',
            required: false
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            required: false,
            ltr: true
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/partners-types',
        entityType: 'partnerTypes',
        schema: 'partnerTypeSchema',
        listSchema: 'partnerTypeListSchema',
        name: 'סוג שותף',
        namePlural: 'סוגי שותפים'
      },
      partnerRelationship: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          }
        },
        endpoint: '/partners-relationships',
        entityType: 'partnerRelationships',
        schema: 'partnerRelationshipSchema',
        listSchema: 'partnerRelationshipListSchema',
        name: 'סוג קשר',
        namePlural: 'סוגי קשרים'
      },
      language: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          code: {
            type: 'TEXT',
            name: 'קוד שפה',
            validationRules: [v => !!v || 'חובה להזין קוד'],
            required: true,
            ltr: true
          }
        },
        endpoint: '/languages',
        entityType: 'languages',
        schema: 'languageSchema',
        listSchema: 'languageListSchema',
        name: 'שפה',
        namePlural: 'שפות'
      },
      contactDetailType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          icon: {
            type: 'ICON',
            name: 'אייקון',
            ltr: true
          },
          formatAsPhoneNumber: {
            type: 'BOOLEAN',
            name: 'הצגה כמספר טלפון'
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/contact-detail-types',
        entityType: 'contactDetailTypes',
        schema: 'contactDetailTypeSchema',
        listSchema: 'contactDetailTypeListSchema',
        name: 'סוג פרטי התקשרות',
        namePlural: 'סוגי פרטי התקשרות'
      },
      country: {
        systemSetup: true,
        model: {
          name: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [v => !!v || 'חובה להזין שם'],
            required: true
          },
          nameEn: {
            type: 'TEXT',
            name: 'שם אנגלית',
            validationRules: [v => !!v || 'חובה להזין שם באנגלית'],
            required: true,
            ltr: true
          },
          iso2Code: {
            type: 'TEXT',
            name: 'קוד מדינה ISO2',
            validationRules: [
              v => !!v || 'חובה להזין קוד מדינה',
              v => v.length === 2 || 'קוד בפורמט לא תקין'
            ],
            required: true,
            ltr: true
          },
          capital: {
            type: 'TEXT',
            name: 'עיר בירה',
            validationRules: [
            ],
            required: false,
            ltr: true
          },
          phoneCode: {
            type: 'TEXT',
            name: 'קידומת בינלאומית',
            validationRules: [
            ],
            required: false,
            ltr: true
          },
          phoneCode: {
            type: 'TEXT',
            name: 'קידומת בינלאומית',
            validationRules: [
            ],
            required: false,
            ltr: true
          },
          isActive: {
            type: 'BOOLEAN',
            name: 'מדינה פעילה',
            required: false,
          },
          standardGroups: {
            type: 'SELECT',
            items: 'standardGroups',
            itemText: 'name',
            itemValue: '_id',
            isMultiple: true,
            name: 'קבוצות תקן',
            required: false
          }
        },
        endpoint: '/countries',
        getParams: {
          fields: 'name,nameEn,iso2Code,phoneCode,capital,isActive,description',
          sort: 'name',
          limit: 0
        },
        entityType: 'countries',
        schema: 'countrySchema',
        listSchema: 'countryListSchema',
        fullscreenEditDialog: false,
        name: 'מדינה',
        namePlural: 'מדינות'
      },
      fullCountry: {
        model: {
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            validationRules: [],
            required: false,
            // hiddenForSystemSetup: true
          }
        },
        endpoint: '/countries',
        entityType: 'countries',
        schema: 'countrySchema',
        listSchema: 'countryListSchema',
        fullscreenEditDialog: true,
        name: 'תיאור מדינה',
        namePlural: 'מדינות'
      },
      region: {
        systemSetup: true,
        model: {
          name: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [v => !!v || 'חובה להזין שם'],
            required: true
          },
          nameEn: {
            type: 'TEXT',
            name: 'שם אנגלית',
            validationRules: [],
            required: false,
            ltr: true
          },
          country: {
            type: 'SELECT',
            items: 'countries',
            itemText: 'name',
            itemValue: '_id',
            isMultiple: false,
            name: 'מדינה',
            // validationRules: [v => !!v.length || 'יש לבחור מדינה אחת לפחות'],
            required: true
          },
          majorCity: {
            type: 'TEXT',
            name: 'עיר עיקרית',
            validationRules: [],
            required: false
          },
          standardGroups: {
            type: 'SELECT',
            items: 'standardGroups',
            itemText: 'name',
            itemValue: '_id',
            isMultiple: true,
            name: 'קבוצות תקן',
            required: false
          }
        },
        endpoint: '/regions',
        getParams: {
          fields: 'name,nameEn,country,standardGroup',
          sort: 'name',
          limit: 0
        },
        entityType: 'regions',
        schema: 'regionSchema',
        listSchema: 'regionListSchema',
        fullscreenEditDialog: false,
        name: 'איזור',
        namePlural: 'איזורים'
      },
      fullRegion: {
        systemSetup: false,
        model: {
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            validationRules: [],
            required: false,
            hiddenForSystemSetup: true
          }
        },
        endpoint: '/regions',
        getParams: {},
        entityType: 'regions',
        schema: 'regionSchema',
        listSchema: 'regionListSchema',
        fullscreenEditDialog: true,
        name: 'תיאור איזור',
        namePlural: 'איזורים'
      },
      mapMarkerType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          icon: {
            type: 'TEXT',
            name: 'אייקון',
            validationRules: [v => !!v || 'חובה להזין אייקון'],
            required: true,
            ltr: TextTrackCue
          },
          order: {
            type: 'NUMBER',
            name: 'סדר תצוגה',
            validationRules: [],
            hint: 'מספר גבוה מופיע למעלה',
            required: false,
            ltr: true
          }
        },
        endpoint: '/map-markers-types',
        entityType: 'mapMarkerTypes',
        schema: 'mapMarkerTypeSchema',
        listSchema: 'mapMarkerTypeListSchema',
        name: 'סוג נקודת עניין',
        namePlural: 'סוגי נקודות עניין'
      },
      eventType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          titlePlural: {
            type: 'TEXT',
            name: 'כותרת (רבים)',
            validationRules: [v => !!v || 'חובה להזין כותרת ברבים'],
            required: true
          },
          color: {
            type: 'COLOR',
            name: 'צבע',
            required: false
          },
        },
        endpoint: '/event-types',
        entityType: 'eventTypes',
        schema: 'eventTypeSchema',
        listSchema: 'eventTypeListSchema',
        name: 'סוג אירוע',
        namePlural: 'סוגי אירועים'
      },
      evacuationType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          titlePlural: {
            type: 'TEXT',
            name: 'כותרת (רבים)',
            validationRules: [v => !!v || 'חובה להזין כותרת ברבים'],
            required: true
          },
        },
        endpoint: '/evacuation-types',
        entityType: 'evacuationTypes',
        schema: 'evacuationTypeSchema',
        listSchema: 'evacuationTypeListSchema',
        name: 'סוג פינוי',
        namePlural: 'סוגי פינויים'
      },
      eventSubType: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          eventType: {
            type: 'SELECT',
            items: 'eventTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג אירוע',
            // validationRules: [v => !!v.length || 'יש לבחור מדינה אחת לפחות'],
            required: true
          },
        },
        endpoint: '/event-sub-types',
        entityType: 'eventSubTypes',
        schema: 'eventSubTypeSchema',
        listSchema: 'eventSubTypeListSchema',
        name: 'תת סוג אירוע',
        namePlural: 'תת סוגי אירועים'
      },
      eventSource: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          }
        },
        endpoint: '/event-sources',
        entityType: 'eventSources',
        schema: 'eventSourceSchema',
        listSchema: 'eventSourceListSchema',
        name: 'מקור אירוע',
        namePlural: 'מקורות אירועים'
      },
      role: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'קוד',
            validationRules: [
              v => !!v || 'חובה להזין קוד',
              v => {
                if (['ADMIN', 'EVENT_MANAGER', 'RESEARCHER', 'USER'].indexOf(v) === -1) return 'קוד לא תקין';
                return true;
              }
            ],
            required: true
          },
          isDutyRole: {
            type: 'BOOLEAN',
            name: 'האם תפקיד באירוע?',
            validationRules: [],
            required: false
          }
        },
        endpoint: '/roles',
        entityType: 'roles',
        schema: 'roleSchema',
        listSchema: 'roleListSchema',
        name: 'סוג הרשאה',
        namePlural: 'סוגי הרשאות'
      },
      gender: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          key: {
            type: 'TEXT',
            name: 'קוד',
            validationRules: [
              v => !!v || 'חובה להזין קוד',
              v => {
                if (['MALE', 'FEMALE', 'OTHER'].indexOf(v) === -1) return 'קוד לא תקין';
                return true;
              }
            ],
            required: true
          }
        },
        endpoint: '/genders',
        entityType: 'genders',
        schema: 'genderSchema',
        listSchema: 'genderListSchema',
        name: 'זוויג',
        namePlural: 'סוגי זוויגים'
      },
      insuranceCompany: {
        systemSetup: true,
        model: {
          name: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [v => !!v || 'חובה להזין שם'],
            required: true
          },
          isOurPartner: {
            type: 'BOOLEAN',
            name: 'האם שותפים שלנו',
            validationRules: [],
            required: false
          }
        },
        endpoint: '/insurance-companies',
        entityType: 'insuranceCompanies',
        schema: 'insuranceCompanySchema',
        listSchema: 'insuranceCompanyListSchema',
        name: 'חברת ביטוח',
        namePlural: 'חברות ביטוח'
      },
      hashtag: {
        systemSetup: true,
        model: {
          title: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [
              v => !!v || 'חובה להזין שם',
              v => {
                if (v && v.indexOf(' ') >= 0) {
                  return 'יש להזין תאג ללא רווחים'
                } else {
                  return true;
                }
              }
            ],
            required: true
          }
        },
        endpoint: '/hashtags',
        entityType: 'hashtags',
        schema: 'hashtagSchema',
        listSchema: 'hashtagListSchema',
        name: 'תאג צ׳אט',
        namePlural: 'תאגיות צ׳אט'
      },
      duty: {
        model: {
          user: {
            type: 'SELECT',
            items: 'users',
            itemText: 'name',
            itemValue: '_id',
            name: 'שם',
            isMultiple: false,
            validationRules: [v => !!v || 'חובה לבחור משתמש'],
            required: true
          },
          role: {
            type: 'SELECT',
            itemsGetter: {
              getter: 'events/userEventRoles',
              depandsOn: 'user'
            },
            // items: 'roles',
            itemText: 'title',
            itemValue: '_id',
            name: 'תפקיד',
            isMultiple: false,
            validationRules: [v => !!v || 'חובה לבחור תפקיד'],
            required: true
          },
          startDate: {
            type: 'DATETIME',
            name: 'זמן תחילת תפקיד',
            validationRules: [
              v => !!v || 'חובה להזין זמן תחילת תפקיד',
              v => {
                if (Date.parse(v) === NaN) {
                  return 'יש להזין תאריך ושעה'
                } else {
                  return true;
                }
              }
            ],
            required: true
          },
          endDate: {
            type: 'DATETIME',
            name: 'זמן סיום תפקיד (בסגירת אירוע, מוזן אוטומטי אם ריק)',
            validationRules: [],
            required: false
          },
          event: {
            hidden: true
          }
        },
        endpoint: '/duties',
        entityType: 'duties',
        schema: 'dutySchema',
        listSchema: 'dutyListSchema',
        name: 'תפקיד',
        namePlural: 'תפקידים'
      },
      standardReportRow: {
        model: {

        },
        endpoint: '/standards/report',
        entityType: 'standardReportRows',
        schema: 'standardReportRowSchema',
        listSchema: 'standardReportRowListSchema'
      },
      customer: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם',
            validationRules: [v => !!v || 'חובה להזין שם'],
            required: true
          },
          nameEn: {
            type: 'TEXT',
            name: 'טלפון',
            validationRules: [
              v => !v || /^[0-9+\-\s()]*$/.test(v) || 'מספר טלפון לא תקין'
            ],
            hint: 'למשל: 972501234567',
            ltr: true,
            required: false
          },
         // nameEn: {
         //   type: 'TEXT',
         //   name: 'שם באנגלית',
         //   validationRules: [],
          //  ltr: true,
        //    required: false
       //   },
          age: {
            type: 'NUMBER',
            name: 'גיל',
            validationRules: [],
            required: true
          },
          id: {
            type: 'TEXT',
            name: 'מס׳ זהות',
            validationRules: [
              // v => {
              //   if (!!v && !israelIdValidator(v.trim())) return 'מספר זהות לא תקין'
              //   else return true
              // }
            ],
            required: false
          },
          passport: {
            type: 'TEXT',
            name: 'מספר דרכון',
            validationRules: [],
            required: false
          },
          insuranceCompany: {
            type: 'SELECT',
            items: 'insuranceCompanies',
            itemText: 'name',
            itemValue: '_id',
            name: 'חברת ביטוח',
            isMultiple: false,
            validationRules: [],
            required: false
          },
          policyNumber: {
            type: 'TEXT',
            name: 'מספר פוליסה',
            validationRules: [],
            required: false
          },
          sar: {
            type: 'BOOLEAN',
            name: 'כיסוי איתור וחילוץ',
            validationRules: [],
            required: false
          },
          imei: {
            type: 'TEXT',
            name: 'IMEI מכשיר לוויני',
            validationRules: [],
            required: false
          },
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            validationRules: [],
            required: false
          },
          gender: {
            type: 'SELECT',
            items: 'genders',
            itemText: 'title',
            itemValue: '_id',
            name: 'מין',
            isMultiple: false,
            validationRules: [],
            required: true
          },
          status: {
            type: 'TEXT',
            name: 'סטטוס',
            validationRules: [],
            required: false
          },
          event: {
            hidden: true
          },
        },
        fullscreenEditDialog: true,
        endpoint: '/customers',
        entityType: 'customers',
        schema: 'customerSchema',
        listSchema: 'customerListSchema',
        name: 'מחולצ/ת',
        namePlural: 'מחולצים'
      },
      user: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם מלא',
            validationRules: [v => !!v || 'חובה להזין שם מלא'],
            required: true
          },
          roles: {
            type: 'SELECT',
            items: 'roles',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: true,
            name: 'הרשאות',
            validationRules: [],
            required: false
          },
          firebaseId: {
            type: 'SELECT',
            items: 'firebaseUsers',
            itemText: 'data',
            itemValue: '_id',
            isMultiple: true,
            name: 'חשבונות',
            validationRules: [],
            required: false
          },
          slackId: {
            type: 'TEXT',
            name: 'מזהה Slack',
            validationRules: [],
            required: false,
            ltr: true
          },
          image: {
            type: 'IMAGE',
            name: 'תמונה',
            validationRules: [],
            required: false,
          },
          color: {
            type: 'COLOR',
            name: 'צבע',
            validationRules: [],
            required: false,
          },
          autoInviteToSlackChannel: {
            type: 'BOOLEAN',
            name: 'צירוף אוטומטי לערוצי אירוע',
            validationRules: [],
            required: false,
          },
          isActive: {
            type: 'BOOLEAN',
            name: 'משתמש פעיל',
            validationRules: [],
            required: false,
          }
        },
        endpoint: '/users',
        entityType: 'users',
        schema: 'userSchema',
        listSchema: 'userListSchema',
        name: 'משתמש',
        namePlural: 'משתמשים'
      },
      event: {
        model: {
          title: {
            type: 'TEXT',
            name: 'כותרת',
            validationRules: [v => !!v || 'חובה להזין כותרת'],
            required: true
          },
          type: {
            type: 'SELECT',
            items: 'eventTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'סוג אירוע',
            validationRules: [v => !!v || 'חובה לבחור סוג אירוע'],
            required: true
          },
          subType: {
            type: 'SELECT',
            itemsGetter: {
              getter: 'events/typeSubTypes',
              depandsOn: 'type'
            },
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'תת סוג אירוע',
            validationRules: [],
            required: false
          },
          source: {
            type: 'SELECT',
            items: 'eventSources',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'מקור אירוע',
            validationRules: [v => !!v || 'חובה לבחור מקור אירוע'],
            required: true
          },
          countries: {
            type: 'SELECT',
            items: 'countries',
            itemText: 'name',
            itemValue: '_id',
            isMultiple: true,
            aggregateFrom: 2,
            name: 'מדינות',
            validationRules: [v => !!v.length || 'יש לבחור מדינה אחת לפחות'],
            required: true
          },
          regions: {
            type: 'SELECT',
            itemsGetter: {
              getter: 'countries/countryRegions',
              depandsOn: 'countries'
            },
            itemText: 'name',
            itemValue: '_id',
            isMultiple: true,
            aggregateFrom: 4,
            name: 'איזורים',
            validationRules: [],
            required: false
          },
          startDate: {
            type: 'DATETIME',
            name: 'זמן תחילת אירוע',
            validationRules: [v => !!v || 'חובה להזין זמן תחילת אירוע'],
            required: true
          },
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            placeholder: 'יש למלא עד משפט אחד קצר, שמסביר מה מהות האירוע. לדוגמא: "נתקעו בסופת השלגים, חולצו על ידי מגן", "קלקול קיבה", "במחלת גבהים"',
            validationRules: [v => !!v || 'חובה להזין תיאור'],
            required: true
          },
          evacuationType: {
            type: 'SELECT',
            items: 'evacuationTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            name: 'אופן פינוי',
            validationRules: [],
            required: false
          },
          includedInHarelReports: {
            type: 'BOOLEAN',
            name: 'אירוע מוכר בהראל (לצורך דו״חות)',
            validationRules: [],
            required: false
          },
          debriefing: {
            type: 'BOOLEAN',
            name: 'האירוע תוחקר',
            validationRules: [],
            required: false
          },
          aran: {
            type: 'ARAN',
            name: 'ארן',
            validationRules: [],
            required: false
          }
        },
        fullscreenEditDialog: true,
        endpoint: 'events',
        entityType: 'events',
        schema: 'eventSchema',
        listSchema: 'eventListSchema',
        name: 'פרטי אירוע'
      },

      closeEvent: {
        model: {
          endDate: {
            type: 'DATETIME',
            name: 'זמן סיום אירוע',
            validationRules: [v => !!v || 'חובה להזין זמן סיום אירוע'],
            required: true
          }
        },
        fullscreenEditDialog: false,
        endpoint: 'events',
        entityType: 'events',
        schema: 'eventSchema',
        listSchema: 'eventListSchema',
        name: 'סיום אירוע'
      },

      chatMessageTags: {
        model: {
          tags: {
            type: 'SELECT',
            name: 'תאגים',
            items: 'hashtags',
            itemText: 'title',
            itemValue: 'title',
            isMultiple: true,
            required: false,
            value: ['יומן_אירועים'],
            initialSelection: true
          }
        },
        fullscreenEditDialog: false,
        endpoint: 'chat-messages',
        entityType: 'chatMessages',
        schema: 'chatMessageSchema',
        listSchema: 'chatMessageListSchema',
        name: 'תאגים'
      },

      standard: {
        model: {
          partnerType: {
            type: 'SELECT',
            name: 'סוג ספק',
            items: 'partnerTypes',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: false,
            required: true
          },
          value: {
            type: 'NUMBER',
            name: 'תקן',
            required: true
          }
        },
        fullscreenEditDialog: false,
        endpoint: 'standards',
        entityType: 'standards',
        schema: 'standardSchema',
        listSchema: 'standardListSchema',
        name: 'תקנים'
      },

      standardGroup: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם הקבוצה',
            required: true
          },
          standards: {
            type: 'SELECT',
            name: 'תקנים',
            items: 'standards',
            itemText: 'title',
            itemValue: '_id',
            isMultiple: true,
            required: true
          },
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            required: false
          }
        },
        fullscreenEditDialog: false,
        endpoint: 'standard-groups',
        entityType: 'standardGroups',
        schema: 'standardGroupSchema',
        listSchema: 'standardGroupListSchema',
        name: 'קבוצת תקנים'
      },

      partnerEventFile: {
        model: {
          description: {
            type: 'TEXTAREA',
            name: 'תיאור',
            required: true
          }
        },
        fullscreenEditDialog: false,
        endpoint: 'partner-event-files',
        entityType: 'partnerEventFiles',
        schema: 'partnerEventFileSchema',
        listSchema: 'partnerEventFileListSchema',
        name: 'קובץ משודך'
      },

      activityLog: {
        endpoint: 'activity-logs',
        entityType: 'activityLogs',
        schema: 'activityLogSchema',
        listSchema: 'activityLogListSchema',
        name: 'לוג פעולות'
      },

      aran: {
        model: {
          name: {
            type: 'TEXT',
            name: 'שם ארן',
            required: false
          }
        },
        endpoint: 'aran',
        entityType: 'arans',
        schema: 'aranSchema',
        listSchema: 'aranListSchema',
        name: 'ארן',
        namePlural: 'ארנים'
      },

    },

    // UI
    fetching: false,
    nightMode: false,
    isMainMenuActive: null,
    shouldShowMainMenuAutomatically: true,
    mainMenuMiniVariant: false,
    snackbar: false,
    snackbarData: {
      text: '',
      color: ''
    },

    // System data
    contactDetailTypes: null,
    eventModules: [
      {
        name: 'EVENT_DETAILS',
        title: 'פרטי אירוע'
      },
      {
        name: 'MAP',
        title: 'מפה'
      },
      {
        name: 'CHAT',
        title: 'צ׳אט'
      },
      {
        name: 'CUSTOMERS',
        title: 'מחולצים'
      },
      {
        name: 'CONTACTS',
        title: 'אנשי קשר'
      },
      {
        name: 'PARTNERS',
        title: 'ספקים'
      },
      {
        name: 'TRANSLATORS',
        title: 'מתורגמנים'
      }
      // {
      //   name: 'TIMELINE',
      //   title: 'ציר זמן'
      // },
    ],
  },
  actions,
  mutations,
  getters
})


// WEBPACK FOOTER //
// ./src/store/index.js